import Grid2 from '@mui/material/Unstable_Grid2';

import ResponsiveImage from '@/components/Image/ResponsiveImage';
import GridContainer2 from '@/components/Layout/GridContainer2/GridContainer2';
import { GlobalListImageCardContent } from '@/components/TopLevelComponents/GlobalList/GlobalList';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './ImageList.styles';

interface ImageListProps {
  list: GlobalListImageCardContent[] | undefined;
  isOnDark?: boolean | undefined;
}

export default function ImageList({ list, isOnDark }: ImageListProps) {
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const { classes, cx } = useStyles({ isOnDark });

  const ImageListItem = ({ item }: { item: GlobalListImageCardContent }) => {
    const { image, heading, body, chipText } = item.fields;

    return (
      <Grid2 xs={6} className={classes.ImageListItem}>
        {image?.[0] && (
          <ResponsiveImage
            className={classes.image}
            src={image[0]}
            width={120}
            height={120}
            sizes={{ xs: 120 }}
            decorative
          />
        )}

        <div className={classes.itemBody}>
          <div className={cx(globalClasses.h4, classes.heading)}>
            {heading}
            {chipText && (
              <span className={cx(globalClasses.chip, classes.chip)}>
                {chipText}
              </span>
            )}
          </div>
          <p className={cx(globalClasses.body, classes.body)}>{body}</p>
        </div>
      </Grid2>
    );
  };

  return (
    <GridContainer2 fixed>
      {list &&
        list.map((item, index) => (
          <ImageListItem key={`icon-list-item-${index}`} item={item} />
        ))}
    </GridContainer2>
  );
}
